export default __webpack_public_path__ + "static/media/bonus.710ddaad.png";